import React from 'react'
import { Form, Button } from 'semantic-ui-react'

export default class EditQuestionForm extends React.Component {
    state = { topic: '', text: '', specs: '' }

    componentDidMount() {
        if (this.props.question)
            this.setState(this.props.question)
    }

    componentDidUpdate(prevProps) {
        if (this.props.question !== prevProps.question)
            this.setState(this.props.question)
    }

    handleChange = (e, { name, value }) => this.setState({ [name]: value })

    onSubmit = (e) => {
        e.preventDefault()
        if (this.props.onSubmit)
            this.props.onSubmit(this.state)
    }


    render() {
        const { topic, text, specs } = this.state
        const { onCancelEdit } = this.props
        return <Form onSubmit={this.onSubmit}>
            <Form.Input label='Argomento' name='topic' value={topic} onChange={this.handleChange} />
            <Form.Input label='Domanda' name='text' value={text} onChange={this.handleChange} />
            <Form.TextArea label='Specifiche' name='specs' value={specs} onChange={this.handleChange} />
            <Button primary type='submit'>Salva</Button>
            <Button onClick={onCancelEdit}>Chiudi</Button>
        </Form>
    }
}


// WEBPACK FOOTER //
// ./src/components/EditQuestionForm.js